export default __webpack_public_path__ + "static/media/finder.4ec08d85.svg";